import React, { ReactNode } from "react";
import Concular from "assets/images/logo_concular.svg";
import OneIcon from "assets/images/teaser_one.svg";
import CircularAssetIcon from "assets/images/logo_circular_asset.png";
import AuthImage from "assets/images/auth-img.png";
import Toast from "components/Toast";
import { globalStore } from "store/GlobalStore";
import { observer } from "mobx-react-lite";
import { IS_CONCULAR_ONE, IS_CIRCULAR_ASSET } from "utils";
import clsx from "clsx";
import ProfileMenu from "features/User/ProfileMenu";

interface IProps {
  children?: ReactNode;
  noLogo?: boolean;
  className?: string;
  containerClassName?: string;
  showLogout?: boolean;
}

const AuthLayout = ({
  children,
  noLogo,
  className,
  containerClassName,
  showLogout,
}: IProps) => {
  let icon = Concular;

  if (IS_CONCULAR_ONE) {
    icon = OneIcon;
  } else if (IS_CIRCULAR_ASSET) {
    icon = CircularAssetIcon;
  }

  return (
    <div className={clsx("flex min-w-full", className)}>
      <div
        id="auth-container"
        className={clsx(
          "flex flex-col xl:w-2/3 lg:w-3/4 sm:w-full h-screen",
          containerClassName
        )}
      >
        {showLogout && (
          <div className="flex">
            <ProfileMenu onboarding />
          </div>
        )}
        <div className="lg:mb-0 md:min-w-[500px] flex flex-col items-center justify-center mx-auto flex-grow">
          {!noLogo && (
            <img
              width={IS_CONCULAR_ONE || IS_CIRCULAR_ASSET ? 300 : 150}
              src={icon}
              alt="Concular"
              className="mx-auto mb-[100px]"
            />
          )}
          {children}
        </div>
      </div>

      <div id="side-image" className="w-1/3 hidden md:block overflow-hidden">
        <img
          src={AuthImage}
          alt="Building"
          className="min-h-full object-cover"
        />
      </div>

      <Toast toastList={globalStore.toastList} />
    </div>
  );
};

export default observer(AuthLayout);
